// Module
var code = "<div class=\"ui-grid-cell-contents u-flexEnd\">\n    <div class=\"u-flex u-flexMiddle\" ng-class=\"{'is-negative-charge' : row.entity.isNegative}\" ng-bind=\"row.entity.balance\"></div>\n</div>\n";
// Exports
module.exports = code;